export const AUTH_LOGIN = '/auth/login';
export const AUTH_2FA = '/auth/2fa';

export const AUTH_LOGOUT = '/logout';

export const EMAIL_SEND = '/verify/email/send';
export const EMAIL_VERIFY_BY_CODE = '/verify/email/submit';
export  const  EMAIL_CHECK = '/verify/email/check';

export const PASSWORD_VERIFY = '/verify/password';

export const MOBILE_SEND = '/verify/mobile/send';
export const MOBILE_VERIFY_BY_CODE = '/verify/mobile/submit';
export const MOBILE_CHECK = '/verify/mobile/check';

export const USER = '/user/{user_id}';

export const USER_2FA_CHECK = '/user/2fa';

export const USER_2FA_MOBILE = '/user/mobile';

export const USER_TOTP_CONFIRM = '/user/totp/confirm';

export const USER_TOTP_REQUEST = '/user/totp/get';

export const AUTH_TEST = '/auth/test'; // Test if user has a valid token

export const REGISTER = '/register/new';
// export const REGISTER_VERIFY_MOBILE = '/register/2fa/mobile';
// export const REGISTER_VERIFY_MOBILE_CHECK = '/verify/mobile/submit';
export const REGISTER_SEARCH = '/register/search';
export const REGISTER_2FA_TOTP = '/register/2fa/totp';

export const CUSTOMER_STATUS = '/customer/{customer_id}/check-in-complete';
export const CUSTOMER_READ = '/customer/{customer_id}';
export const CUSTOMER_UPDATE = '/customer/{customer_id}';
export const CUSTOMER_RESERVATION = '/customer/{customer_id}/reservation';
export const CUSTOMER_IMAGE = '/customer/{customer_id}/image/{tag}';
export const CUSTOMER_FILE__GET_UPLOAD = '/customer/{customer_id}/files';
export const CUSTOMER_FILE__GET_ONE = '/customer/{customer_id}/files/{attachment_id}';
export const CUSTOMER_FILE__DELETE = '/customer/{customer_id}/files/{attachment_id}';
export const CUSTOMER_SECURITY_QUESTIONS = '/customer/{customer_id}/security-questions';
export const CUSTOMER_ACCESS = '/customer/{customer_id}/access';
export const CUSTOMER_PEOPLE = '/customer/{customer_id}/people';
export const CUSTOMER_PERSON = '/customer/{customer_id}/people/{person_id}';
export const CUSTOMER_DIRECT_DEBIT = '/customer/{customer_id}/direct-debit';
export const CUSTOMER_DIRECT_DEBIT_CONFIRM ='/customer/{customer_id}/direct-debit/confirm/{token}';
export const CUSTOMER_DIRECT_DEBIT_DELETE ='/customer/{customer_id}/direct-debit/{directDebitId}';
export const CUSTOMER_STORAGE_AGREEMENT = '/customer/{customer_id}/terms/storage';
export const CUSTOMER_TERMS = '/customer/{customer_id}/terms';
export const CUSTOMER_DOMESTIC = '/customer/{customer_id}/details-domestic';
export const CUSTOMER_BUSINESS = '/customer/{customer_id}/details-business';
export const CUSTOMER_BUSINESS_PRIMARY = '/customer/{customer_id}/people/primary';

export const CUSTOMER_DONATION = '/customer/{customer_id}/donation';

export const CUSTOMER_INVENTORY__GET_POST = '/customer/{customer_id}/inventory';
export const CUSTOMER_INVENTORY__PATCH_DELETE = '/customer/{customer_id}/inventory/{inventory_id}';

export const CUSTOMER_LINK_RESERVATION = '/user/{user_id}/link-reservation';
export const CUSTOMER_ACCOUNTS = '/user/{user_id}/customer-accounts'
export const CUSTOMER_SUBCONTRACTS = '/customer/{customer_id}/subcontracts'
export const CUSTOMER_SUBCONTRACTS__PATCH = '/customer/{customer_id}/subcontracts/{subContractId}';
export const CUSTOMER_SUBCONTRACTS_REASONS = '/contract/reasons'

export const CUSTOMER_MOVE_IN_DATE_PATCH = '/customer/rental-date/{reservation_id}';

export const CHANGE_PASSWORD = '/change-password';
export const INVENTORY = '/inventory';

export const RESET_PASSWORD_STEP1 = '/user/reset-password/1';
export const RESET_PASSWORD_STEP2 = '/user/reset-password/2';
export const RESET_PASSWORD_STEP3 = '/user/reset-password/3';

export const ADDRESS_LOOKUP_BY_POSTCODE = '/location-lookup/postcode/{postcode}';
export const ADDRESS_LOOKUP_BY_ID = '/location-lookup/address/{id}';
export const STORE_GET = '/store/{storeId}';
export const SITE_UNDER_MAINTENANCE = '/ping';
export const LOGGER = '/client-log';

export const MOVE_IN_BLOCKED_DATES = '/excluded-dates/move-in';
export const YOTI_ACCOUNT_HOLDER_URL = '/check-in/{customerId}/security-access/documents/';

export const YOTI_ACCOUNT_HOLDER_PROGRESS =
    '/customer/{customer_id}/identification-in-progress';
